module.exports = {
      id: "full-screen-icon-usage",
      viewBox: undefined,
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#full-screen-icon",
      toString: function () {
        return this.url;
      }
    }